<template>
  <div class="service">
    <!--顶部轮播 -->
    <div class="swpier">
      <img :src="swiperImage" alt="">
    </div>
    <div class="menu">
      <div class="menu-lsit"  id="quality1">
        <div href="#" class="menu-lsit-item" :class="menuIndex == index ? 'menu-lsit-item_' : ''"
          v-for="(item, index) in menuList" :key="index" @click="goAnchor(index)">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="product animated-fadeInUp" id="quality" data-wow-delay="0.4s" style="animation-name: fadeInUp;">
      <div class="product-cont">
        <div class="product-box">
          <div class="quality-system-box">
            <div class="quality-system-title">{{menuList[0].name}}</div>
            <div class="quality-system-list">
              <div class="quality-system-list-item" v-for="(item, index) in list[menuList[0].id]" :key="index">
                <div class="item-image product-image">
                  <img class="images" :src="item.image" alt="">
                </div>
                <div class="item-title">
                  {{ item.title }}
                </div>
                <div class="item-content">
                  {{ item.description }}
                </div>
              </div>
            </div>
            
            <div id="after1"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="after-sales" id="after">
      <div class="product animated-fadeInUp" data-wow-delay="0.4s" style="animation-name: fadeInUp;">
        <div class="product-cont">
          <div class="product-box">
            <div class="after-sales-box">
              <div class="after-sales-title">{{menuList[1].name}}</div>

              <div class="after-sales-lsit">
                <div class="after-sales-lsit-item" v-for="(item, index) in list[menuList[1].id]" :key="index"
                  :style="'background-image:' + 'url(' + item.image + ')'">
                  <div class="after-sales-lsit-item-box">
                    <div class="item-title">
                      {{ item.title }}
                    </div>
                    <div class="item-line"></div>
                    <div class="Email item-fone-size">
                      <img src="../../../static/image/Email.png" alt="">
                      <div>
                        Email：{{ item.email }}
                      </div>
                    </div>
                    <div class="item-fone-size">
                      <img src="../../../static/image/Telephone.png" alt="">
                      <div> Tel：{{ item.tel }}</div>

                    </div>
                    <div class="item-fone-size">
                      <img src="../../../static/image/Address.png" alt="">
                      <div> Address：{{ item.address }}</div>
                    </div>
                  </div>
                </div>
                
                <div id="common1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product animated-fadeInUp" id="common" data-wow-delay="0.4s" style="animation-name: fadeInUp;">
      <div class="product-cont">
        <div class="product-box">
          <div class="common-problem-box">
            <div class="common-problem-title">{{menuList[2].name}}</div>
            <div class="common-problem-list">
              <div class="common-problem-list-item" v-for="(item, index) in list[menuList[2].id]" :key="index">
                <div class="common-problem-list-item-index">{{ index + 1 > 9 ? index + 1 : '0' + (index + 1) }}</div>
                <div class="common-problem-list-item-box">
                  <div class="common-problem-list-item-title">{{ item.title }}</div>
                  <div class="common-problem-list-item-content">{{ item.description }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="downloadcenter"  v-if="menuList[3]" id="download1">
      <div class="downloadcenter-box">
        <div class="downloadcenter-title">{{menuList[3].name}}</div>
        <p class="downloadcenter-button button-hover" @click="getTap">
          Go now <i class="el-icon-right"></i>
        </p>
      </div>
    </div>
    <footerBotom></footerBotom>
  </div>
</template>
<script>
import { serviceCate ,serviceList,nav} from '@/request/api'
import footerBotom from '@/components/footer.vue'
export default {
  components: {
    footerBotom
  },
  data() {
    return {
      menuList: [],
      menuIndex: 0,
      list: [],
      swiperImage:""
    }
  },
  created() {
    this.getNav()
    this.getMenuList()
    this.getList()
  },
  mounted() {
    this.to = this.$route.query.to || null;
    this.goAnchor(this.to,true);
  },
  methods: {
    getNav(){
      nav({}).then(res=>{
        this.swiperImage = res.data[3].image
      })
    },
    getMenuList() {
      serviceCate().then(res => {
        if (res.code == 1) {
          this.menuList = res.data
        }
      })
    },
    getList(){
      serviceList({}).then(res=>{
        if(res.code == 1){
          this.list = res.data.list
        }
      })
    },
    goAnchor(index,flag) {/*参数selector是id选择器（#anchor14）*/
      this.menuIndex = index
      let selector = ""
      if (index == 0) {
        // selector = "#quality"
        selector = "#quality1"
      }
      if (index == 1) {
        // selector = "#after"
        selector = "#after1"
      }
      if (index == 2) {
        // selector = "#common"
        selector = "#common1"
      }
      if (index == 3 && flag) {
        // selector = "#download"
        selector = "#download1"
      }
      if (index == 3 && !flag) {
        this.getTap()
        return
      }
      if (flag) {
        setTimeout(res => {
          document.querySelector(selector).scrollIntoView({
            behavior: "smooth"
          });
         }, 1601);
        return;
      }
      document.querySelector(selector).scrollIntoView({
        behavior: "smooth"
      });
      // this.menuIndex = index
      // let selector = ""
      // if (index == 0) {
      //   selector = "#quality"
      // }
      // if (index == 1) {
      //   selector = "#after"
      // }
      // if (index == 2) {
      //   selector = "#common"
      // }
      // if (index == 3) {
      //   this.getTap()
      //   return
      // }
      // document.querySelector(selector).scrollIntoView({
      //   behavior: "smooth"
      // });
    },
    getTap() {
      this.$router.push({
        path: '/download'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.swpier {
  margin-top: 90px;
  width: 100%;

  img {
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
}

.menu {
  height: 57px;
  background: #131823;

}

.menu-lsit {
  display: flex;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
  justify-content: center;


}

.menu-lsit-item {
  display: block;
  text-align: center;
  width: 164px;
  height: 57px;
  line-height: 57px;
  font-size: 16px;

  color: #FFFFFF !important;
  cursor: pointer;
}

.menu-lsit-item_ {
  background: #DB2733 !important;
}

.menu-lsit-item:hover {
  background: #DB2733;
}

.quality-system-box {
  margin-top: 15px;

  .quality-system-title {
    text-align: center;
    font-size: 36px;
    font-family: Arial-Bold, Arial;
    font-weight: bold;
    color: #333333;
  }

  .quality-system-list {
    display: flex;
    align-items: self-start;
    flex-wrap: wrap;
    margin-top: 65px;

    .quality-system-list-item {
      width: calc(100% / 4);
      text-align: center;

      .item-image {
        // cursor: pointer;
        margin: 0 auto;
      }

      .item-title {
        margin-top: 30px;
        font-size: 18px;

        color: #333333;
      }

      .item-content {
        margin: 0 auto;
        margin-top: 13px;
        width: 310px;

        font-size: 15px;

        color: #999999;
      }
    }
  }
}

.after-sales {
  background: #F7F7F7;

  .after-sales-box {
    .after-sales-title {
      text-align: center;
      font-size: 36px;
      font-family: Arial-Bold, Arial;
      font-weight: bold;
      color: #333333;
    }

    .after-sales-lsit {
      margin-top: 32px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .after-sales-lsit-item {
        margin-right: 30px;
        width: 100%;
        background-size: 100% 100%;
        height: 337px;
        margin-bottom: 30px;
      }

      .after-sales-lsit-item:last-child {
        margin-right: 0;
      }

      .after-sales-lsit-item-box {
        padding: 49px 63px;

        .item-title {
          font-size: 24px;
          font-family: Arial-Bold, Arial;
          font-weight: bold;
          color: #FFFFFF;
        }

        .item-line {
          margin-top: 21px;
          width: 36px;
          height: 3px;
          background: #FFFFFF;
        }

        .Email {
          margin-top: 50px;
        }

        .item-fone-size {
          margin-bottom: 24px;
          font-size: 15px;

          font-weight: 400;
          color: #FFFFFF;
          display: flex;
          align-items: self-start;

          div {
            margin-left: 12px;
          }
        }
      }
    }
  }
}

.common-problem-box {
  .common-problem-title {
    text-align: center;
    font-size: 36px;
    font-family: Arial-Bold, Arial;
    font-weight: bold;
    color: #333333;
  }

  .common-problem-list {
    margin-top: 43px;

    .common-problem-list-item {
      margin-bottom: 40px;
      position: relative;
      display: flex;
      align-items: center;

      .common-problem-list-item-index {
        position: absolute;
        width: 59px;
        text-align: center;
        line-height: 59px;
        height: 59px;
        background: #DB2733;
        border-radius: 100%;
        font-size: 23px;

        color: #FFFFFF;
      }

      .common-problem-list-item-box {
        width: calc(100% - 156px);
        padding: 28px 63px;
        background: #F7F7F7;
        margin-left: 30px;

        .common-problem-list-item-title {
          font-size: 24px;
          font-family: Arial-Bold, Arial;
          font-weight: bold;
          color: #DB2733;
          padding-bottom: 20px;
          border-bottom: 1px solid #C7C7C7;
        }

        .common-problem-list-item-content {
          margin-top: 18px;
          font-size: 16px;

          color: #666666;
          line-height: 24px;
        }
      }
    }
  }
}

.downloadcenter {
  background-image: url('../../../static/image/downloadcenter-bg.png');
  width: 100%;
  height: 374px;
  display: flex;
  align-items: center;
  justify-content: center;

  .downloadcenter-title {
    text-align: center;
    font-size: 36px;
    font-family: Arial-Bold, Arial;
    font-weight: bold;
    color: #333333;
  }

  .downloadcenter-button {
    cursor: pointer;
    display: block;
    width: 348px;
    height: 66px;
    margin-top: 37px;
    line-height: 68px;
    background: #DB2733;
    border-radius: 33px 33px 33px 33px;
    text-align: center;
    font-size: 22px;

    font-weight: 400;
    color: #FFFFFF;
  }
}

@media screen and (max-width:767px) {
  .quality-system-box {
    .quality-system-list-item {
      width: calc(100% / 2) !important;
      margin-bottom: 30px;

      .item-content {
        width: 100% !important;
      }
    }
  }

  .after-sales-box {
    .after-sales-lsit {
      display: block !important;

      .after-sales-lsit-item {
        width: 100% !important;

        .after-sales-lsit-item-box {
          padding: 30px !important;
        }
      }

    }
  }

  .common-problem-list {
    .common-problem-list-item-box {
      padding-left: 60px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/service/service.vue